import { Button } from "@/components/ui/button";
import { AppointmentJoin } from "@/repositories/appointments.repository";
import { isUnassignable, mayChangeWorkerPay, mayGiveWorker } from "@/lib/appointment-assignment";

interface WorkerAssignmentProps {
  appointment: AppointmentJoin;
  busy: boolean;
  onAssign: () => void;
  onUnassign: () => void;
}

export default function WorkerAssignment({ appointment, busy, onAssign, onUnassign }: WorkerAssignmentProps) {
  const { id: workerId, name: workerName } = appointment.assigned_user ?? {};
  if (!workerId) {
    return (
      <span className="flex items-center gap-2">
        <span className="text-amber-600">Not assigned</span>
        {mayGiveWorker(appointment.status, false) && (
          <Button variant="outline" size="sm" className="text-green-600 hover:text-green-700 h-6 text-xs" onClick={onAssign}>
            Assign
          </Button>
        )}
      </span>
    );
  }
  return (
    <span className="flex items-center gap-2">
      <span className="text-green-600">{workerName?.trim() || "Assigned individual"}</span>
      {mayChangeWorkerPay(appointment.status, true) && (
        <Button variant="outline" size="sm" className="h-6 text-xs" onClick={onAssign} disabled={busy}>
          Change Pay
        </Button>
      )}
      {isUnassignable(appointment.status, true) && (
        <Button variant="outline" size="sm" className="text-red-600 hover:text-red-700 h-6 text-xs" onClick={onUnassign} disabled={busy}>
          {busy ? "..." : "Unassign"}
        </Button>
      )}
    </span>
  );
}
